import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'


//获取微信
export function getWxJSAPISign(data) {
    return fetch({
        url: config.WEB_WX_JSAPI_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}